import React from 'react';

import PreSaleForm from '../../../components/staff/pre-sale-form';

const PreSaleCreate = () => (
  <>
    <h1>Crear pre-venta</h1>
    <PreSaleForm action='create'/>
  </>
);

export default PreSaleCreate;
